module.exports = __webpack_public_path__ + "static/media/diego-schellenberg.936b685a.jpg";